import React from 'react';
import { PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300" data-id="element-58">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-59">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-60">
          <div data-id="element-61">
            <h3 className="text-white text-lg font-semibold mb-4" data-id="element-62">
              Fire Safety Displays
            </h3>
            <p className="mb-4" data-id="element-63">Trusted Fire Safety Experts Since 1980</p>
          </div>
          <div data-id="element-64">
            <h3 className="text-white text-lg font-semibold mb-4" data-id="element-65">
              The System
            </h3>
            <ul className="space-y-2" data-id="element-66">
              <li data-id="element-67">
                <a href="#" className="hover:text-white" data-id="element-68">
                  Evacuation Displays
                </a>
              </li>
              <li data-id="element-69">
                <a href="#" className="hover:text-white" data-id="element-70">
                  I.D. Signs
                </a>
              </li>
              <li data-id="element-71">
                <a href="#" className="hover:text-white" data-id="element-72">
                  Emergency Employee Pamphlets
                </a>
              </li>
              <li data-id="element-73">
                <a href="#" className="hover:text-white" data-id="element-74">
                  Fire Department Information
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-75">
            <h3 className="text-white text-lg font-semibold mb-4" data-id="element-76">
              I.D. Sign Catalog
            </h3>
            <ul className="space-y-2" data-id="element-77">
              <li data-id="element-78">
                <a href="#" className="hover:text-white" data-id="element-79">
                  Fire Signs
                </a>
              </li>
              <li data-id="element-80">
                <a href="#" className="hover:text-white" data-id="element-81">
                  Exit Signs
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="hover:text-white" data-id="element-83">
                  Safety Signs
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-white" data-id="element-85">
                  OSHA Safety Signs
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-white" data-id="element-87">
                  Miscellaneous Signs
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-88">
            <h3 className="text-white text-lg font-semibold mb-4" data-id="element-89">
              Contact Us
            </h3>
            <div className="space-y-3" data-id="element-90">
              <div className="flex items-start" data-id="element-91">
                <PhoneIcon className="h-5 w-5 mr-3 mt-0.5" data-id="element-92" />
                <span data-id="element-93">Contact For Info</span>
              </div>
              <div className="flex items-start" data-id="element-94">
                <MailIcon className="h-5 w-5 mr-3 mt-0.5" data-id="element-95" />
                <span data-id="element-96">info@firesafetydisplays.com</span>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-sm text-center" data-id="element-97">
          <p data-id="element-98">
            &copy; {new Date().getFullYear()} Fire Safety Displays. All rights
            reserved.
          </p>
          <p className="mt-2" data-id="element-99">
            **Pardon Our Dust, Our Page is Currently Under Construction**
          </p>
        </div>
      </div>
    </footer>;
}